var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLongtext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20655_283708",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20655_283708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.30775 18.6058C5.07892 18.6058 4.88708 18.5293 4.73225 18.3765C4.57742 18.2237 4.5 18.0343 4.5 17.8083C4.5 17.5823 4.57742 17.391 4.73225 17.2345C4.88708 17.0782 5.07892 17 5.30775 17H12.75C12.9625 17 13.1406 17.0728 13.2843 17.2185C13.4281 17.364 13.5 17.5443 13.5 17.7595C13.5 17.972 13.4282 18.1502 13.2845 18.294C13.141 18.4377 12.966 18.5095 12.7595 18.5095L5.30775 18.6058ZM5.25 14.6635C5.0375 14.6635 4.85942 14.5916 4.71575 14.4478C4.57192 14.3039 4.5 14.1257 4.5 13.913C4.5 13.7005 4.57192 13.5224 4.71575 13.3788C4.85942 13.2353 5.0375 13.1635 5.25 13.1635H18.75C18.9625 13.1635 19.1406 13.2354 19.2843 13.3793C19.4281 13.5231 19.5 13.7013 19.5 13.9138C19.5 14.1264 19.4281 14.3045 19.2843 14.448C19.1406 14.5917 18.9625 14.6635 18.75 14.6635H5.25ZM5.25 10.8365C5.0375 10.8365 4.85942 10.7646 4.71575 10.6208C4.57192 10.4769 4.5 10.2988 4.5 10.0863C4.5 9.8736 4.57192 9.69552 4.71575 9.55202C4.85942 9.40835 5.0375 9.33652 5.25 9.33652H18.75C18.9625 9.33652 19.1406 9.40843 19.2843 9.55227C19.4281 9.6961 19.5 9.87435 19.5 10.087C19.5 10.2995 19.4281 10.4776 19.2843 10.6213C19.1406 10.7648 18.9625 10.8365 18.75 10.8365H5.25ZM5.30775 7.00002C5.07892 7.00002 4.88708 6.9226 4.73225 6.76777C4.57742 6.61293 4.5 6.4211 4.5 6.19227C4.5 5.96343 4.57742 5.7716 4.73225 5.61676C4.88708 5.4621 5.07892 5.38477 5.30775 5.38477H18.6923C18.9211 5.38477 19.1129 5.4621 19.2678 5.61676C19.4226 5.7716 19.5 5.96343 19.5 6.19227C19.5 6.4211 19.4226 6.61293 19.2678 6.76777C19.1129 6.9226 18.9211 7.00002 18.6923 7.00002H5.30775Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongtext);
export default __webpack_public_path__ + "static/media/longtext.c101578b5224281fec13958f0a07570a.svg";
export { ForwardRef as ReactComponent };